import React from 'react';
import Button from './Button';
import '../../../styles/parentPortal.css';

export default function ErrorBlock({ message, onRetry }) {
  return (
    <div role="alert" className="pp-card" style={{ padding: 'var(--space-6) var(--space-4)', textAlign: 'center' }}>
      <p style={{ color: 'var(--text-secondary)', fontSize: 'var(--text-body-size)', margin: '0 0 var(--space-4)' }}>
        {message || 'Something went wrong.'}
      </p>
      {onRetry && (
        <Button variant="secondary" onClick={onRetry}>
          Try again
        </Button>
      )}
    </div>
  );
}
